export default "__VITE_ASSET__31a3b22e__"